export const INITIAL_DATA_REQUEST = 'INITIAL_DATA_REQUEST';
export const INITIAL_DATA_SUCCESS = 'INITIAL_DATA_SUCCESS';
